// import request from '@/middleware/request'

// const getIntent = () => {
//   return request({
//     url: '/intents',
//     method: 'get'
//   })
// }

// const getTrainingPhrasesByIntent = id => {
//   return request({
//     url: `/intents/training-phrases-intent/${id}`,
//     method: 'get'
//   })
// }

// const createIntent = data => {
//   return request({
//     url: '/intents',
//     method: 'post',
//     data
//   })
// }

// const updateIntent = (id, data) => {
//   return request({
//     url: `/intents/${id}`,
//     method: 'patch',
//     data
//   })
// }

// const deleteIntent = (id, data) => {
//   return request({
//     url: `/intents/${id}`,
//     method: 'delete',
//     data
//   })
// }

// export default {
//   getIntent,
//   getTrainingPhrasesByIntent,
//   createIntent,
//   updateIntent,
//   deleteIntent
// }

import request from '@/middleware/request'

const getIntent = () => {
  return request({
    url: '/ai/legacy/intents',
    method: 'get'
  })
}

export default {
  getIntent
}
